<ng-template #loaderContent>
  <div class="loader-content flex--nogrow align-center">
    <h2 class="font-heading-3" *ngIf="title">{{ title | finLocalization }}</h2>
    <div class="loader-spacer pr-medium-y">
      <div class="loader" [ngClass]="color"></div>
    </div>
    <div class="loader-for font-body-1" *ngIf="paragraph">{{ paragraph | finLocalization }}</div>
  </div>
</ng-template>

<ng-container [ngSwitch]="loaderType">
  <!-- CASE 1/5: FULL_SCREEN -->
  <div *ngSwitchCase="LoaderTheme.FULL_SCREEN" class="loader-container fixed z5 top-left fill grow">
    <div class="loader-wrapper grid-max-width center grow flex flex--center nordic-blue-900-text white-bg">
      <ng-container *ngTemplateOutlet="loaderContent"></ng-container>
    </div>
  </div>

  <!-- CASE 2/5: EMBEDDED -->
  <div *ngSwitchCase="LoaderTheme.EMBEDDED" class="nordic-blue-900-text pr-large-y">
    <ng-container *ngTemplateOutlet="loaderContent"></ng-container>
  </div>

  <!-- CASE 3/5: INLINE -->
  <div *ngSwitchCase="LoaderTheme.INLINE" class="font-body-1">
    <div class="loader" [ngClass]="color"></div>
  </div>

  <!-- CASE 4/5: INLINE_TEXT -->
  <div *ngSwitchCase="LoaderTheme.INLINE_TEXT" class="font-body-1 inline-block pr-small-x">
    <div class="loader" [ngClass]="color"></div>
  </div>

  <!-- CASE 5/5: BUTTON -->
  <div *ngSwitchCase="LoaderTheme.BUTTON" class="font-body-1 inline-block pr-small-x">
    <div class="loader button-loader"></div>
  </div>
</ng-container>
